import styled from 'styled-components';
import { Atom } from 'AppReact';

export const template = styled.div`
  position: absolute;
  width: 14px;
  height: 14px;
  left: -7px;
  top: -7px;

  background-color: #FD2020;
  font-size: 10px;
  line-height: 10px;
  padding-left: 1px;
  padding-left: 2px;
  display: flex;
  align-items: center;
  justify-content: center;
  color: #FFFFFF;

  border-radius: 50%;

  cursor: pointer;
  user-select: none;
`;

export default Atom({ type: 'button', dataType: 'string', template })
